import React, { useEffect, useState } from "react";
import "./Home.css";
import Navbar from "./Navbar.js";
import amc from "../../src/assets/amc.png";
import fms from "../../src/assets/fms.png";
import call from "../../src/assets/call.png";
import smallSrc from "../../src/assets/smallImg.png";
import largeSrc from "../../src/assets/largeImg.png";
import neelesh from "../../src/assets/neeleshshah.jpg";
import servicesmall from "../../src/assets/servicesmall.png";
import servicelarge from "../../src/assets/servicelarge.png";
import krishna from "../../src/assets/krishna.jpg";
import shailesh from "../../src/assets/shailesh.jpg";
import Footer from "./Footer.js";
import { useLocation } from "react-router-dom";

export default function Home() {
  const teamMembers = [
    {
      id: 1,
      name: "Neelesh Shah",
      role: "Partner",
      img: neelesh,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
    {
      id: 2,
      name: "Krishna Bawkar",
      role: "Partner",
      img: krishna,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
    {
      id: 3,
      name: "Shailesh Dube",
      role: "Partner",
      img: shailesh,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
  ];
  const items = [
    "AMC services",
    "Antivirus Software",
    "FMS services",
    "CCTV Installations",
    "Call based services",
    "Repair and maintenance",
  ];
  const TESTIMONIALS = [
    {
      id: 1,
      name: "Priya Sharma",
      role: "Business Manager",
      img: "/images/person1.jpg", // replace with real paths
      stars: 5,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. It has survived not only five centuries...",
    },
    {
      id: 2,
      name: "Arjun Mehta",
      role: "Operations Head",
      img: "/images/person2.jpg",
      stars: 5,
      text: "Exceptional service and quick response. The team handled everything professionally and proactively.",
    },
    {
      id: 3,
      name: "Sonia Rao",
      role: "Entrepreneur",
      img: "/images/person3.jpg",
      stars: 5,
      text: "Very pleased — the work was timely, and the support continues even after the engagement ended.",
    },
  ];
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;

  function prev() {
    setIndex((i) => (i - 1 + total) % total);
  }
  function next() {
    setIndex((i) => (i + 1) % total);
  }

  const t = TESTIMONIALS[index];

  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(
      () => window.history.replaceState(null, "", location.pathname),
      300,
    );
  }, [location]);

  function scheduleMeeting() {
    const baseUrl =
      "https://calendar.google.com/calendar/render?action=TEMPLATE";

    const params = new URLSearchParams({
      add: "neelesh@compserveinfo.com", // fixed attendee
    });

    const finalUrl = `${baseUrl}&${params.toString()}`;

    window.open(finalUrl, "_blank");
  }

  function makeCall() {
    window.location.href = "tel:+919821294451";
  }

  return (
    <div>
      <Navbar />
      <div className="video-container">
        {/* Background Video */}
        <video autoPlay muted loop playsInline className="background-video">
          <source src="/videos/home.mp4" type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>

        {/* Gradient Overlay */}
        <div className="overlay"></div>

        {/* Left-Side Content */}
        <div className="content">
          <p className="text-small">One Stop For All IT Solutions</p>
          <h1 className="text-large">
            Empowering Your Business with Exceptional Technology
          </h1>
          <p className="text-regular">
            Future-Proofing Your Business. Strategic IT Solutions Engineered for
            Growth and Resilience.
          </p>
        </div>
      </div>
      <div className="solution-offered">
        <h2>
          Our Core Solutions: <br /> Driving Your Success
        </h2>
        <span>
          <h6>Services</h6>
          <p>
            Our solutions ensure seamless operation, eliminating downtime and
            security risks.We manage technology so you can focus on core
            business objectives.
          </p>
        </span>
      </div>
      <hr className="line-breaks" />
      <div className="solution-offered-containers">
        <div className="solution-offered-box">
          <img src={amc} alt="solution-1-img" />
          <h3>AMC Services</h3>
          <button onClick={makeCall}>
            <span className="lbl">Book Now &#8599;</span>
          </button>
        </div>
        <div className="solution-offered-box">
          <img src={fms} alt="solution-1-img" />
          <h3>FMS Services</h3>
          <button onClick={makeCall}>
            <span className="lbl">Book Now &#8599;</span>
          </button>
        </div>
        <div className="solution-offered-box">
          <img src={call} alt="solution-1-img" />
          <h3>Call-Based Support</h3>
          <button onClick={makeCall}>
            <span className="lbl">Book Now &#8599;</span>
          </button>
        </div>
      </div>
      <div className="consultation-box">
        <div className="consultation-box-text">
          <h6>Affordable Solutions</h6>
          <h2>Leverage Technology for Growth and Success</h2>
          <h5>
            Experience the reliability and expertise of a leading provider of
            innovative technology solutions. Let us be the trusted partner that
            drives your efficiency and productivity.
          </h5>
          <button onClick={scheduleMeeting}>Get a Consultation</button>
        </div>
        <div className="consultation-box-img">
          <img src={largeSrc} alt="largeImageCOnsult" className="large-img" />
          <img src={smallSrc} alt="smallImageCOnsult" className="small-img" />
        </div>
      </div>
      <div className="solution-offered" id="team">
        <h2>Meet Our Skilled Partners</h2>
        <span>
          <h6>Expert Team</h6>
          <p>
            Our team brings a wealth of experience and knowledge, ensuring we
            stay at the forefront of industry trends and advancements to serve
            you better.
          </p>
        </span>
      </div>
      <hr className="line-breaks" />
      <div className="partners-grid">
        {teamMembers.map((m) => (
          <article key={m.id} className="partner-card">
            <div className="avatar-wrap">
              <img src={m.img} alt={`${m.name}`} className="avatar" />
            </div>

            <div className="partner-info">
              <h3 className="partner-name">{m.name}</h3>
              <p className="partner-role">{m.role}</p>
            </div>

            <div className="partner-socials" aria-hidden={false}>
              {m.socials?.linkedin && (
                <a
                  href={m.socials.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on LinkedIn`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M4.98 3.5C4.98 4.88 3.9 6 2.49 6C1.08 6 .01 4.88 .01 3.5C.01 2.12 1.08 1 2.49 1C3.9 1 4.98 2.12 4.98 3.5zM.2 8.98H4.8V24H.2zM8.98 8.98H13.37V10.78H13.44C13.99 9.83 15.49 8.78 17.57 8.78C21.74 8.78 22 11.5 22 15.25V24H17.4V15.98C17.4 13.99 17.36 11.49 14.62 11.49C11.86 11.49 11.41 13.67 11.41 15.82V24H6.81z" />
                  </svg>
                </a>
              )}

              {m.socials?.twitter && (
                <a
                  href={m.socials.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on Twitter`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.3 4.3 0 0 0 1.88-2.37 8.59 8.59 0 0 1-2.72 1.04 4.28 4.28 0 0 0-7.3 3.9A12.15 12.15 0 0 1 3.15 4.7 4.27 4.27 0 0 0 4.18 10a4.2 4.2 0 0 1-1.94-.54v.05a4.28 4.28 0 0 0 3.43 4.2 4.3 4.3 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98A8.59 8.59 0 0 1 2 19.54 12.12 12.12 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.35-.02-.53A8.36 8.36 0 0 0 22.46 6z" />
                  </svg>
                </a>
              )}

              {m.socials?.instagram && (
                <a
                  href={m.socials.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on Instagram`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 6.1a4.9 4.9 0 1 0 .001 9.801A4.9 4.9 0 0 0 12 8.1zm5.2-2.3a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z" />
                  </svg>
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
      <div className="services-offered-box">
        <div className="services-offered-box-img">
          <img
            src={servicelarge}
            alt="largeImageService"
            className="large-img-service"
          />
          <img
            src={servicesmall}
            alt="smallImageService"
            className="small-img-service"
          />
        </div>
        <div className="services-offered-box-text">
          <h2>Essential IT Products for Immediate Deployment</h2>
          <h5>
            Compserve Services offers reliable hardware and powerful software
            products, including market-leading antiviruses, servers, and
            complete CCTV installations. Find the right technology to secure and
            accelerate your operations.
          </h5>
          <div className="services-grid">
            {items.map((item, i) => (
              <div key={i} className="service-box">
                <span className="tick">✔</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
          <button onClick={makeCall}>Book Now</button>
        </div>
      </div>
      <section className="tc-section" aria-label="Testimonials and contact">
        <div className="tc-inner">
          {/* Left - Heading + nav */}
          <div className="tc-left">
            <h2 className="tc-title">
              Feedback About Their Experience With Us
            </h2>
            <p className="tc-desc">
              Read testimonials from our satisfied clients. See how our services
              have made a difference in their lives and businesses.
            </p>

            <div className="tc-controls">
              <button
                className="tc-btn outline"
                onClick={prev}
                aria-label="Previous testimonial"
              >
                <svg viewBox="0 0 24 24" className="arrow">
                  <path
                    d="M15 18l-6-6 6-6"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                className="tc-btn filled"
                onClick={next}
                aria-label="Next testimonial"
              >
                <svg viewBox="0 0 24 24" className="arrow">
                  <path
                    d="M9 6l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Right - Testimonial card */}
          <div className="tc-right" role="region" aria-live="polite">
            <article className="testimonial-card">
              <div className="testimonial-left">
                <img src={t.img} alt={`${t.name}`} className="t-avatar" />
              </div>

              <div className="testimonial-body">
                <div className="t-header">
                  <div>
                    <h3 className="t-name">{t.name}</h3>
                    <p className="t-role">{t.role}</p>
                    <div className="t-stars" aria-hidden>
                      {Array.from({ length: t.stars }).map((_, i) => (
                        <svg key={i} viewBox="0 0 24 24" className="star">
                          <path d="M12 17.3L7.2 20l1-5.6L4 11.5l5.8-.5L12 5l2.2 6 5.8.5-4.2 3.0 1 5.6z" />
                        </svg>
                      ))}
                    </div>
                  </div>

                  <div className="t-quote" aria-hidden>
                    <svg viewBox="0 0 24 24" className="quote">
                      <path d="M7 7h4v4H7zM13 7h4v4h-4z" />
                    </svg>
                  </div>
                </div>

                <p className="t-text">{t.text}</p>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section className="contact-section" aria-label="Contact section">
        <div className="contact-inner">
          {/* LEFT: Find us */}
          <div className="contact-left">
            <h2 className="contact-heading">Find us</h2>

            <div className="info-card">
              <div className="info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" className="icon-svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.09 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.37 1.77.73 2.59a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.82.36 1.69.61 2.59.73A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>

              <div className="info-body">
                <h3 className="info-title">Call Us</h3>
                <div className="info-text">
                  <a href="tel:+02249603325">02249603325</a> /{" "}
                  <a href="tel:+02249603324">24</a>
                  <br />
                  <a href="tel:+02223894450">02223894450</a> /{" "}
                  <a href="tel:+02223894451">51</a>
                </div>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" className="icon-svg">
                  <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v.01l8 5 8-5V6H4zm16 12V9.24l-7.39 4.62a1 1 0 0 1-1.22 0L4 9.24V18h16z" />
                </svg>
              </div>

              <div className="info-body">
                <h3 className="info-title">Email Now</h3>
                <div className="info-text">
                  <a href="mailto:service@compsrveinfo.com">
                    service@compserveinfo.com
                  </a>
                </div>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon" aria-hidden>
                <svg viewBox="0 0 24 24" className="icon-svg">
                  <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zM12 11.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
                </svg>
              </div>

              <div className="info-body">
                <h3 className="info-title">Address</h3>
                <div className="info-text">
                  <a href="https://maps.app.goo.gl/QUurPRJFjHRg6zNA6">
                    C/O TURF PRINTING WORKS, 31 TRIBHUVAN ROAD,OFF LAMINGTON RD.,MUMBAI:-400004
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: Keep In Touch */}
          <div className="contact-right">
            <p className="contact-pretitle">Contact info</p>
            <h2 className="contact-right-heading">Keep In Touch</h2>
            <p className="contact-desc">
              We prioritize responding to your inquiries promptly to ensure you
              receive the assistance you need in a timely manner.
            </p>

            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                className="form-input"
                placeholder="Name"
                required
              />
              <input
                type="email"
                className="form-input"
                placeholder="Email"
                required
              />
              <textarea
                className="form-textarea"
                placeholder="Message"
                required
              />
              <button className="form-btn" type="submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
